/*
 * @Author: Json Chen
 * @Date: 2021-07-15 09:41:35
 * @LastEditTime: 2022-02-11 16:36:11
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/ModalContents.tsx
 */

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export const DelModalContent = ({
  onModalCancel,
  onModalConfirm,
  children,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <React.Fragment>
      {children}
      <ModalFooter
        onCancel={onModalCancel}
        okText={getI18n('general.delete')}
        danger
        onOk={onModalConfirm}
      />
    </React.Fragment>
  );
};
